<template>
    <div v-html="policyList">
    </div>
</template>
<script>
import { 
    apiBizGetDefaultPolicy,
    apiEditLandlordPolicy,
    apiDeleteLandlordPolicy
} from "@/apis/api.js"; 

export default {
    data () {
        return {
            policyList: null
        }
    },
    mounted() { 
        this.$analyticsBiz.logEvent('預設條款', { screen_name: '預設條款'})
        this.getPolicy()
    },
    methods: {
        getPolicy: function () {
            apiBizGetDefaultPolicy()
            .then(res =>{
                console.log(res)
                if(res.status === 200){
                    this.policyList = res.data
                }else{
                    console.log('Policy err')
                }
            })
            .catch(err =>{
                console.log(err)
            })
        },
    }
}
</script>
<style lang="scss">
    .contract-block{
        margin-left: auto;
        margin-right: auto;
    }
</style>


// WEBPACK FOOTER //
// src/pages/bussiness/otherPage/DefaultPolicy.vue